import angular from 'angular';
import FineTuneVideosService from './FineTuneVideosService';
import fineTuneVideosComponent from './fineTuneVideosComponent';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/modal/modalModule';
import 'components/sharpr/clearableInput/clearableInputModule';
import 'components/sharpr/date/dateRangePicker/dateRangePickerModule';

angular
	.module('sh.fineTuneVideos', ['sh.api', 'sh.identity', 'sh.modal', 'sh.clearableInput', 'sh.dateRangePicker'])
	.component('shFineTuneVideos', fineTuneVideosComponent())
	.service('FineTuneVideos', FineTuneVideosService);
